import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { ArrowBlock, OptionsListElement, RelativeBlock } from '../../../Blocks/components/common/StyledEditables';

const Code = ({ active }) =>
<RelativeBlock>
    <OptionsListElement>
      <Icon
      name="hyperlink"
      color="white"
      size={24} />

      <ArrowBlock
      active={active}
      name="arrowdown"
      color="white"
      size={12} />

    </OptionsListElement>
  </RelativeBlock>;


export default Code;